import logo from '../logo.svg';
import logo4896 from '../client-logo/4896.svg';
import { getDownloadURL, ref } from 'firebase/storage';
import { useEffect, useState, memo } from 'react';
import { storage } from '../utils/firebase';
function Logo({ companyId }: { companyId: string }) {
  const [link, setLink] = useState('');
  useEffect(() => {
    if (companyId) {
      getDownloadURL(ref(storage, `logo/${companyId}.jpg`))
        .then(setLink)
        .catch(() => {
          console.log('**** no custom logo found ****');
          setLink(logo);
        });
    }
  }, [companyId]);

  if (link) {
    return <img src={link} className='w-[74px] mb-12' alt='CheckN Logo' />;
  } else {
    return <img src={logo} className='w-[74px] mb-12' alt='CheckN Logo' />;
  }
  // if (companyId === '4896') {
  //   return <img src={logo4896} className='w-1/4 md:w-1/6 mb-20 mt-10' alt='CheckN Logo' />;
  // }
  // return <img src={logo} className='w-1/4 md:w-1/6 mb-20 mt-10' alt='CheckN Logo' />;
}

export default memo(Logo);
